var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRotateItemIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1998 4.40001C17.9598 4.40001 20.7318 5.45601 22.8318 7.56801C27.0558 11.78 27.0558 18.62 22.8318 22.832C20.7318 24.944 17.9598 26 15.1998 26C13.4118 26 11.6238 25.544 10.0038 24.656L11.7918 22.868C12.8718 23.348 14.0358 23.6 15.1998 23.6C17.3478 23.6 19.4958 22.784 21.1398 21.14C24.4158 17.864 24.4158 12.536 21.1398 9.26001C19.4958 7.61601 17.3478 6.80001 15.1998 6.80001V10.688L10.1118 5.60001L15.1998 0.512009V4.40001ZM8.40832 7.29204L0.632324 15.08L8.42032 22.856L16.2083 15.08L8.40832 7.29204ZM4.02842 15.08L8.42042 10.688L12.8004 15.08L8.40842 19.472L4.02842 15.08Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateItemIcon);
export default __webpack_public_path__ + "static/media/rotate-item-icon.997594e635929abed7ee080d4adae07d.svg";
export { ForwardRef as ReactComponent };